
import { IndustrySelection } from "@/components/IndustrySelection";
import LoadedScore from "@/components/LoadedScore";
import LoadedScoreOverview from "@/components/LoadedScoreOverview";
import { Button } from "@/components/ui/button";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useSession } from '@supabase/auth-helpers-react';

const ScorePage = () => {
  const session = useSession();
  const [hasExistingScore, setHasExistingScore] = useState(false);
  const [showIndustrySelection, setShowIndustrySelection] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkExistingAssessment();
  }, [session]);

  const checkExistingAssessment = async () => {
    if (!session?.user?.id) {
      setIsLoading(false);
      return;
    }

    try {
      const { data } = await supabase
        .from('profiles')
        .select('assessment_completed, last_assessment_date')
        .eq('id', session.user.id)
        .maybeSingle();

      setHasExistingScore(!!data?.assessment_completed);
    } catch (error) {
      console.error('Error checking assessment status:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="container mx-auto px-3 sm:px-4 py-4 sm:py-6 md:py-8">
        <div className="text-center">Loading...</div>
      </div>
    );
  }

  if (hasExistingScore) {
    return (
      <div className="container mx-auto px-3 sm:px-4 py-4 sm:py-6 md:py-8">
        <LoadedScore />
        <div className="text-center mt-4 sm:mt-6 md:mt-8 mb-8 sm:mb-10 md:mb-16">
          <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-2 md:mb-4">Need to update your score?</h3>
          <p className="text-xs sm:text-sm md:text-base text-text-secondary mb-3 sm:mb-4 md:mb-6 px-2 leading-relaxed">
            Your industry or role changed? Start a new assessment to update your Loaded Score™
          </p>
          <Button 
            className="bg-primary hover:bg-primary-hover w-full sm:w-auto touch-target-min"
            size="sm"
            onClick={() => {
              setHasExistingScore(false);
              setShowIndustrySelection(true);
            }}
          >
            Start New Assessment
          </Button>
        </div>
      </div>
    );
  }

  if (!showIndustrySelection) {
    return (
      <div className="container-fluid p-0 overflow-x-hidden">
        <LoadedScoreOverview onStart={() => setShowIndustrySelection(true)} />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-3 sm:px-4 py-4 sm:py-6 md:py-8">
      <IndustrySelection />
    </div>
  );
};

export default ScorePage;
